<template>
  <div v-if="session == true" id="id01" class="modal1">
    <span onclick="document.getElementById('id01').style.display='none'" class="close1" title="Close Modal">×</span>
    <form class="modal-content1" action="/action_page.php">
      <div class="container1">
        <h3>هل تريد حذف الطلب السابق ؟</h3><br>

        <div class="clearfix1">
          <DxButton class="cancelbtn" text="لا" @click="async () => {

            this.changevalue(false);
          }" />

          <DxButton class="deletebtn" text="نعم" @click="async () => {

            this.Refresh();
          }" />
        </div>
      </div>
    </form>
  </div>
  <div v-else class="t">
    <div class="container" v-if="loading == true">
      <!--<div class="loader"></div>-->
      <div id="overlayer"></div>
      <span class="loader">
        <span class="loader-inner"></span>
      </span>
    </div>
    <div v-else>      
      <div v-if="type == 'Inventory'">
        <div class="flex-container">
          <div class="box left">          
            <DxTagBox 
              class="padding custom-tagbox"        
              :rtlEnabled="true"
              :items="DxTag_items_groups"
              :value="DxTag_value_groups"
              :show-selection-controls="true"
              value-expr="Seq"
              display-expr="Name"
              placeholder="اختر المادة الرئيسية ..."
              @value-changed="onMaterialChanged"
              :multiline="false" 
            />
          </div>
          <div class="box right">            
            <DxLookup v-if="warehouse_names.length > 1 && countItems==0" :rtlEnabled="true" placeholder="اختر المستودع ..." class="padding"
              :items="warehouse_names" v-model:value="warehouseName" @value-changed="onWarehouseChange">
            </DxLookup>
            <DxLookup v-else :disabled="true" :rtlEnabled="true" placeholder="اختر المستودع ..." class="padding"
              :items="warehouse_names" v-model:value="warehouseName" @value-changed="onWarehouseChange">
            </DxLookup>
          </div>
        </div>
        <div class="textRTL">          
          
          <div class="toggle-switch m-2 textRTL">            
            <label class="switch">
              <input type="checkbox" v-model="checked_paging" @change="change_checked_paging">
              <span class="slider"></span>
            </label>
            <span class="label-text">{{ checked_paging ? 'مقدار الزيادة' : 'تفعيل قارء الباركود' }}</span>
            <input  v-if="checked_paging" type="number" id="input2" placeholder="Enter Quantity" v-model="quantity_barcode"  min="1" @change="change_quantity_barcode"/>          
            <input v-if="checked_paging" id="input" @keydown="handleEnterKey" placeholder="Enter Barcode" enterkeyhint="enter" />            
            <DxButton v-if="map_Inventory.get(warehouseName) == true" class="padding" text="إرسال الجرد" @click="() => {
            Update_Inventory(true)
          }" />
          <DxButton v-else class="padding" text="إرسال الطلب" @click="() => {
            this.boo_currentOrder = false;
            
            Update_Inventory(false)
          }" />
          
          <DxButton  v-if="this.boo_currentOrder == false && this.boo_PrevOrder == false" class="padding" text="عرض الطلب الحالي " @click="() => {
            this.boo_currentOrder = true;
            this.InventoryMetrial_CurrentOrder = [];
            for(let i =0;i<this.InventoryMetrial.length;i++){
                if (this.InventoryMetrial[i]['qty_send'] != '' || this.InventoryMetrial[i]['qty_send2'] != '' || this.InventoryMetrial[i]['qty_send3'] != '') {
                    this.InventoryMetrial_CurrentOrder.push(this.InventoryMetrial[i]);
                }
            }
            
            
          }" />
          <!--<DxButton  v-else-if="this.boo_currentOrder && this.boo_PrevOrder == false" class="padding" text="الطلبات المضافة مسبقا" @click="() => {
            this.boo_PrevOrder = true;     
            this.boo_currentOrder = false;                                    
          }" />-->
          <DxButton v-else  class="padding" text="الرجوع لقائمة المود" @click="() => {
            this.boo_currentOrder = false;       
            this.boo_PrevOrder = false;                               
          }" />
          </div>            
        </div>
        <!--:column-auto-width="true" v-model:focused-row-key="focusedRowKey"  -->
        <DxDataGrid ref="dateGridRef" noDataText="لا يوجد بيانات لعرضها" :rtlEnabled="true" id="gridContainer"
            @exporting="onExporting"  :show-row-lines="true" class="padding" :columns="columns"
            :show-borders="true" :data-source="boo_currentOrder ? InventoryMetrial_CurrentOrder : (boo_PrevOrder ? InventoryMetrial_PrevuiosOrder : InventoryMetrial)  " :allow-column-reordering="true"
            :allow-column-resizing="true"  key-expr="seq"                   
            @row-updated="onRowUpdated"          
            @cell-prepared="onRowPrepared"          
            :height="'80vh'"
            @option-changed="onOptionChanged"
            @row-removing="onRowRemoving"
            :master-detail="{enabled:true , template:'detailTemplate'}"
            :focused-row-enabled="true"
            :focused-row-key="focusedRowKey"
            >
          <DxExport :enabled="true"></DxExport>
          <dx-paging :enabled="checked_paging || (InventoryMetrial !=null && InventoryMetrial.length > 10) ? true : false" :page-size="10" />
          <DxPager
            :show-page-size-selector="true"
            :allowed-page-sizes="[5, 10, 20 ,40]"
            :show-info="true"
            info-text="Page {0} of {1} ({2} items)"
          />
          <DxColumnFixing :enabled="true" />
          <DxHeaderFilter />
          <DxFilterRow />
          <DxEditing  v-if="ch == true" :allow-updating="true" mode="popup"  :allow-deleting="true"/>
          <DxEditing  v-else :allow-updating="true" mode="cell" :allow-deleting="true"/>      
          <DxColumn :visible="(col_num || col_num == 'true') ? true : false" :rtlEnabled="true" :filter-operations="allowedOperations"
            v-model:selected-filter-operation="selectedOperation" v-model:filter-value="filterValue_num"
            data-field="num" caption="رقم المادة" :allow-editing="false" />
          <DxColumn :visible="(col_name1 || col_name1 == 'true') ? true : false" :filter-operations="allowedOperations" v-model:selected-filter-operation="selectedOperation"
            v-model:filter-value="filterValue_name" :fixed="true" fixed-position="right" data-field="name1"
            caption="المادة" :allow-editing="false" />
          <DxColumn :visible="(col_barcode || col_barcode=='true') ? true : false" :filter-operations="allowedOperations" v-model:selected-filter-operation="selectedOperation"
            v-model:filter-value="filterValue_barcode" data-field="barcode" caption="باركود المادة"
            :allow-editing="false" />
          <DxColumn :visible="(col_sellpr1 || col_sellpr1 == 'true')? true : false " caption="سعر الجملة" data-field="sellpr1" :allow-editing="false" />
          <DxColumn :visible="(col_sellpr2 || col_sellpr2 == 'true')?true : false " caption="سعر نصف الجملة" data-field="sellpr2" :allow-editing="false" />
          <DxColumn :visible="(col_sellpr3 || col_sellpr3 == 'true')?true : false" caption="سعر المفرق" data-field="sellpr3" :allow-editing="false" />
          <DxColumn :visible="(col_sellpr4 || col_sellpr4 == 'true')?true : false" caption="سعر المستهلك" data-field="sellpr4" :allow-editing="false" />
          <DxColumn :visible="(col_sellpr5 || col_sellpr5 == 'true')?true : false" caption="سعر خاص" data-field="sellpr5" :allow-editing="false" />
          <DxColumn :visible="(col_unt1 || col_unt1 == 'true')?true : false" caption="الجرد بالوحدة الافتراضية" data-field="col_unt1">
            <DxColumn :visible="col_unt_name || col_unt_name == 'true'" caption="الوحدة" data-field="unt_name" :allow-editing="false" />
            <!--<DxColumn data-field="qty_add" caption="الجرد المضاف" />    -->
            <DxColumn :visible="(col_Inventory1 || col_Inventory1 == 'true')?true : false" caption="الجرد" data-field="col_Inventory1">
              <DxColumn  :visible="(col_qty || col_qty == 'true')?true : false"  v-if="map_quantity.get(warehouseName) == true" data-type="number" caption="البرنامج" data-field="qty"
                :allow-editing="false" />
              <DxColumn :visible="(col_qty_active || col_qty_active == 'true')?true : false" data-type="number" data-field="qty_active" caption="الحالي" />
              <DxColumn :visible="(col_expression || col_expression == 'true')?true : false" data-field="expression" caption="المفصل " :allow-editing="false" />
              <DxColumn :visible="(col_qty_send || col_qty_send == 'true')?true : false" data-type="number" data-field="qty_send" caption="النهائي" :allow-editing="false" />
            </DxColumn>
          </DxColumn>
          <DxColumn :visible="(col_unt2 || col_unt2 == 'true')?true : false" caption="ادخال بالوحدة الثانية" data-field="col_unt2">
            <DxColumn :visible="(col_unt_name2 || col_unt_name2 == 'true')?true : false" caption="الوحدة2" data-field="unt_name2" :allow-editing="false" />
            <DxColumn :visible="(col_Inventory2 || col_Inventory2 == 'true')?true : false" caption="الجرد" data-field="col_Inventory2">
              <DxColumn :visible="(col_qty2 || col_qty2 == 'true')?true: false" v-if="map_quantity.get(warehouseName) == true" data-type="number" caption="البرنامج" data-field="qty2"
                :allow-editing="false" />
              <DxColumn :visible="(col_qty_active2 || col_qty_active2 == 'true')?true :false" data-type="number" data-field="qty_active2" caption="الحالي" />
              <!--<DxColumn v-if="ch == true" data-field="qty_add2" caption="الجرد المضاف" />-->
              <DxColumn :visible="(col_expression2 || col_expression2 == 'true') ? true : false" data-field="expression2" caption="المفصل " :allow-editing="false" />
              <DxColumn :visible="(col_qty2 || col_qty2 == 'true') ? true : false" data-type="number" data-field="qty_send2" :allow-editing="false" caption="النهائي" />
            </DxColumn>
          </DxColumn>

          <DxColumn :visible="(col_unt3 || col_unt3 == 'true') ? true : false" caption="ادخال بالوحدة الثالثة" data-field="col_unt3">
            <DxColumn :visible="(col_unt_name3 || col_unt_name3 == 'true') ? true : false" caption="الوحدة3" data-field="unt_name3" :allow-editing="false" />
            <DxColumn :visible="(col_Inventory3 || col_Inventory3 == 'true') ? true : false" caption="الجرد" data-field="col_Inventory3">
              <DxColumn :visible="(col_qty3 || col_qty3 == 'true') ? true : false" v-if="map_quantity.get(warehouseName) == true" data-type="number" data-field="qty3" caption="البرنامج"
                :allow-editing="false" />
              <DxColumn :visible="(col_qty_active3 || col_qty_active3 == 'true') ? true : false" data-type="number" data-field="qty_active3" caption="الحالي"/>
              <!--<DxColumn v-if="ch == true" data-field="qty_add3" caption="الجرد المضاف" />-->
              <DxColumn :visible="(col_expression3 || col_expression3 == 'true') ? true : false" data-field="expression3" caption="المفصل " :allow-editing="false" />
              <DxColumn :visible="(col_qty_send3 || col_qty_send3 == 'true') ? true : false" data-type="number" data-field="qty_send3" :allow-editing="false" caption="النهائي" />
            </DxColumn>
          </DxColumn>
          <DxColumn :visible="col_Remarks || col_Remarks == 'true'"  caption="الملاحظات" data-field="Remarks" />          
          <DxSummary>
            <DxTotalItem  column="num" summary-type="count" display-format="عدد المواد : {0}" />
          </DxSummary>
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <DxHeaderFilter :visible="showHeaderFilter" />
          <DxColumnChooser height="340px" :enabled="true" mode="select">
          </DxColumnChooser>

          <template #detailTemplate="{data:InventoryMetrial}">
              <DxDataGrid
              :data-source="InventoryMetrial.data.other_barcode"
              :show-borders="true"
              :column-auto-width="true"
              >
                <DxColumn dataField="barcode" caption="باركود المادة"/>
                <DxColumn dataField="name" caption="اسم المادة"/>              
              </DxDataGrid>
          </template>
        </DxDataGrid>        
        <v-footer class="d-flex flex-column text-center">
          <div class="bg-teal d-flex w-100 align-center px-4">
            <strong></strong>
            <v-spacer></v-spacer>
          </div>
          <div class="px-4 py-2 bg-blue text-center w-100">
            <!--{{ new Date().getFullYear() }} — <strong>Vuetify</strong>-->
            عدد المواد التي تم تعديل جردها : <strong>{{ countItems }}</strong>
          </div>
        </v-footer>
        <!--<DxButton class="padding" text="تسجيل خروج" @click="Log_out" />-->
        <DxButton class="padding" text="← العودة" @click="goBack" />
      </div>
    </div>
  </div>
</template>
<script>

import FingerprintJS from '@fingerprintjs/fingerprintjs'
import {
  DxDataGrid,
  DxExport, DxColumn, DxColumnFixing
  //,DxScrolling 
  , DxEditing
  , DxPaging
  , DxSummary
  , DxTotalItem
  ,DxPager
  // ,DxLookup
  , DxFilterRow, DxHeaderFilter, DxColumnChooser
  
} from 'devextreme-vue/data-grid';
import { DxLookup } from 'devextreme-vue/lookup';
//import DxLookup from 'devextreme-vue/lookup';
import DxButton from 'devextreme-vue/button';
import axios from 'axios';
import { DeviceUUID } from 'device-uuid';
import { ref } from 'vue';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { DxTagBox } from 'devextreme-vue/tag-box';

export default {

  name: "App",
  dataGridRefKey: '',
  components: {
    DxButton,
    DxDataGrid,
    //DxTreeList
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxEditing,
    DxColumn,
    //  DxScrolling,
    DxColumnFixing,
    DxLookup,
    // DxCheckBox,
    DxColumnChooser,
    DxTotalItem,
    DxSummary,
    //ToggleSwitch ,
    DxExport,
    DxTagBox,
    DxPager
    //DxDropDownBox,DxList
  },
  data: () => ({
    FromDate: new Date().toISOString().slice(0, 10),
    ToDate: new Date().toISOString().slice(0, 10),
    db: null,
    orders: [],
    type: 'Inventory',
    dataGridRef: ref(null),
    input: ref(null),
    myOptions: {
      layout: {
        color: 'black',
        backgroundColor: 'lightgray',
        selectedColor: 'white',
        selectedBackgroundColor: 'green',
        borderColor: 'black',
        fontFamily: 'Arial',
        fontWeight: 'normal',
        fontWeightSelected: 'bold',
        squareCorners: true,
        noBorder: true
      },
      size: {
        height: 2,
        width: 16,
        padding: 0.4,
        fontSize: 1
      },
      config: {
        preSelected: 'On',
        disabled: false,
        items: [
          { name: 'تقرير الطلبات', value: 'Orders', color: 'white', backgroundColor: 'green' },
          { name: 'تعديل كميات', value: 'Inventory', color: 'white', backgroundColor: 'green' }
        ]
      }
    },
    quantity_barcode:localStorage.getItem('quantity_barcode') == '' | localStorage.getItem('quantity_barcode') == null  ? 1 :  parseInt(localStorage.getItem('quantity_barcode')),
    countItems: 0,
    focusedRowKey: 0,
    loading: false,
    map: new Map(),
    map_quantity: new Map(),
    map_Inventory: new Map(),
    map_group: new Map(),
    ch: false,
    groupMat: "0",
    username: '',
    warehouseName: "",
    group: "",
    IdWarhouse: -1,
    warehouse_matrial: '-1',
    locale: "",
    columns: ['num', 'name1', 'seq', 'barcode', 'qty', 'qty2', 'qty3', 'qty_active', 'qty_active2', 'qty_active3', 'qty_add', 'qty_add2', 'qty_add3', 'qty_send', 'qty_send2', 'qty_send3', 'Remarks', 'unt1', 'unt2', 'unt_name'],
    columns1: ['Name', 'num', 'date', 'kind', 'remarks'],
    warehouse: [],
    warehouse_names: [],
    items_groups: [],
    DxTag_items_groups: [],
    InventoryMetrial: [],
    InventoryMetrial_CurrentOrder:[],
    InventoryMetrial_PrevuiosOrder:[],
    boo_currentOrder : false,
    boo_PrevOrder : false,
    showHeaderFilter: true,
    checked_paging: localStorage.getItem("checked_barcode") == null || localStorage.getItem("checked_barcode") == '' ? false : Boolean(localStorage.getItem("checked_barcode")),
    uid: new DeviceUUID().get(),
    showFilterRow: true,
    allowedOperations: ['contains', '='],
    selectedOperation: 'contains',
    filterValue_num: '',
    filterValue_barcode: '',
    filterValue_name: '',
    session: '',
    visitorId:'',
    DxTag_value_groups:'',
    selectedItems2:'',
    existItemUpdated : true,
    col_unt2:localStorage.getItem("col_unt2") == null || localStorage.getItem("col_unt2") == '' ? false : Boolean(localStorage.getItem("col_unt2")),
    col_unt3:localStorage.getItem("col_unt3") == null || localStorage.getItem("col_unt3") == '' ? false : Boolean(localStorage.getItem("col_unt3")),
    col_num:localStorage.getItem("col_num") == null || localStorage.getItem("col_num") == '' ? true : Boolean(localStorage.getItem("col_num")),
    col_name1:localStorage.getItem("col_name1") == null || localStorage.getItem("col_name1") == '' ? true : Boolean(localStorage.getItem("col_name1")),
    col_barcode:localStorage.getItem("col_barcode") == null || localStorage.getItem("col_barcode") == '' ? true : Boolean(localStorage.getItem("col_barcode")),
    col_sellpr1:localStorage.getItem("col_sellpr1") == null || localStorage.getItem("col_sellpr1") == '' ? false : Boolean(localStorage.getItem("col_sellpr1")),
    col_sellpr2:localStorage.getItem("col_sellpr2") == null || localStorage.getItem("col_sellpr2") == '' ? false : Boolean(localStorage.getItem("col_sellpr2")),
    col_sellpr3:localStorage.getItem("col_sellpr3") == null || localStorage.getItem("col_sellpr3") == '' ? false : Boolean(localStorage.getItem("col_sellpr3")),
    col_sellpr4:localStorage.getItem("col_sellpr4") == null || localStorage.getItem("col_sellpr4") == '' ? false : Boolean(localStorage.getItem("col_sellpr4")),
    col_sellpr5:localStorage.getItem("col_sellpr5") == null || localStorage.getItem("col_sellpr5") == '' ? false : Boolean(localStorage.getItem("col_sellpr5")),    
    col_unt1:localStorage.getItem("col_unt1") == null || localStorage.getItem("col_unt1") == '' ? true : Boolean(localStorage.getItem("col_unt1")),
    col_unt_name:localStorage.getItem("col_unt_name") == null || localStorage.getItem("col_unt_name") == '' ? true : Boolean(localStorage.getItem("col_unt_name")),
    col_qty:localStorage.getItem("col_qty") == null || localStorage.getItem("col_qty") == '' ? true : Boolean(localStorage.getItem("col_qty")),
    col_qty_active:localStorage.getItem("col_qty_active") == null || localStorage.getItem("col_qty_active") == '' ? true : Boolean(localStorage.getItem("col_qty_active")),
    col_expression:localStorage.getItem("col_expression") == null || localStorage.getItem("col_expression") == '' ? true : Boolean(localStorage.getItem("col_expression")),
    col_qty_send:localStorage.getItem("col_qty_send") == null || localStorage.getItem("col_qty_send") == '' ? true : Boolean(localStorage.getItem("col_qty_send")),    
    col_unt_name2:localStorage.getItem("col_unt_name2") == null || localStorage.getItem("col_unt_name2") == '' ? false : Boolean(localStorage.getItem("col_unt_name2")),
    col_qty2:localStorage.getItem("col_qty2") == null || localStorage.getItem("col_qty2") == '' ? false : Boolean(localStorage.getItem("col_qty2")),
    col_qty_active2:localStorage.getItem("col_qty_active2") == null || localStorage.getItem("col_qty_active2") == '' ? false : Boolean(localStorage.getItem("col_qty_active2")),
    col_expression2:localStorage.getItem("col_expression2") == null || localStorage.getItem("col_expression2") == '' ? false : Boolean(localStorage.getItem("col_expression2")),
    col_qty_send2:localStorage.getItem("col_qty_send2") == null || localStorage.getItem("col_qty_send2") == '' ? false : Boolean(localStorage.getItem("col_qty_send2")),
    col_unt_name3:localStorage.getItem("col_unt_name3") == null || localStorage.getItem("col_unt_name3") == '' ? false : Boolean(localStorage.getItem("col_unt_name3")),
    col_qty3:localStorage.getItem("col_qty3") == null || localStorage.getItem("col_qty3") == '' ? false : Boolean(localStorage.getItem("col_qty3")),
    col_qty_active3:localStorage.getItem("col_qty_active3") == null || localStorage.getItem("col_qty_active3") == '' ? false : Boolean(localStorage.getItem("col_qty_active3")),
    col_expression3:localStorage.getItem("col_expression3") == null || localStorage.getItem("col_expression3") == '' ? false : Boolean(localStorage.getItem("col_expression3")),
    col_qty_send3:localStorage.getItem("col_qty_send3") == null || localStorage.getItem("col_qty_send3") == '' ? false : Boolean(localStorage.getItem("col_qty_send3")),
    col_Remarks:localStorage.getItem("col_Remarks") == null || localStorage.getItem("col_Remarks") == '' ? false : Boolean(localStorage.getItem("col_Remarks")),
    col_Inventory2:localStorage.getItem("col_Inventory2") == null || localStorage.getItem("col_Inventory2") == '' ? false : Boolean(localStorage.getItem("col_Inventory2")),
    col_Inventory3:localStorage.getItem("col_Inventory3") == null || localStorage.getItem("col_Inventory3") == '' ? false : Boolean(localStorage.getItem("col_Inventory3")),    
    col_Inventory1:localStorage.getItem("col_Inventory1") == null || localStorage.getItem("col_Inventory1") == '' ? true : Boolean(localStorage.getItem("col_Inventory1")),

  }),
  methods: {         
    onOptionChanged(e) {
      if(e.fullName == "paging.pageIndex"){
          /*this.focusedRowKey = null;
          e.component.option('focusedRowKey', null);*/
      }
      if (
        e.fullName?.includes('.visible') &&
        e.fullName?.startsWith('columns')
      ) {
        // استخدم fullName لاستخراج السلسلة الكاملة للموقع في الشجرة
        const columnPath = e.fullName.replace('.visible', '');
        try {
          // اجلب العمود باستخدام path مثل: columns[0].columns[1]
          const column = this.getColumnByPath(e.component, columnPath);
          const dataField = column?.dataField || column?.caption || '(بدون اسم)';
          var dF = dataField;
          if(dataField.includes('col')){
            localStorage.setItem(dataField,e.value);            
          }else{
            localStorage.setItem('col_'+dataField,e.value);
            dF = 'col_'+dataField;
          }
          switch(dF){
              case 'col_unt2':
                this.col_unt2 = e.value;
              break;
              case 'col_unt3':
                this.col_unt3 = e.value;
              break;
              case 'col_num':
                this.col_num = e.value;
              break;
              case 'col_name1':
                this.col_name1 = e.value;
              break;
              case 'col_barcode':
                this.col_barcode = e.value;
              break;
              case 'col_sellpr1':
                this.col_sellpr1 = e.value;
              break;
              case 'col_sellpr2':
                this.col_sellpr2 = e.value;
              break;
              case 'col_sellpr3':
                this.col_sellpr3 = e.value;
              break;
              case 'col_sellpr4':
                this.col_sellpr4 = e.value;
              break;
              case 'col_sellpr5':
                this.col_sellpr5 = e.value;
              break;
              case 'col_unt1':
                this.col_unt1 = e.value;
              break;
              case 'col_unt_name':
                this.col_unt_name = e.value;
              break;
              case 'col_qty':
                this.col_qty = e.value;
              break;
              case 'col_qty_active':
                this.col_qty_active = e.value;
              break;
              case 'col_expression':
                this.col_expression = e.value;
              break;
              case 'col_qty_send':
                this.col_qty_send = e.value;
              break;
              case 'col_unt_name2':
                this.col_unt_name2 = e.value;
              break;
              case 'col_qty2':
                this.col_qty2 = e.value;
              break;
              case 'col_qty_active2':
                this.col_qty_active2 = e.value;
              break;
              case 'col_expression2':
                this.col_expression2 = e.value;
              break;
              case 'col_qty_send2':
                this.col_qty_send2 = e.value;
              break;
              case 'col_unt_name3':
                this.col_unt_name3 = e.value;
              break;
              case 'col_qty3':
                this.col_qty3 = e.value;
              break;
              case 'col_qty_active3':
                this.col_qty_active3 = e.value;
              break;
              case 'col_expression3':
                this.col_expression3 = e.value;
              break;
              case 'col_qty_send3':
                this.col_qty_send3 = e.value;
              break;
              case 'col_Remarks':
                this.col_Remarks = e.value;
              break;
              case 'col_Inventory2':
                this.col_Inventory2 = e.value;
              break;
              case 'col_Inventory3':
                this.col_Inventory3 = e.value;
              break;
              case 'col_Inventory1':
                this.col_Inventory1 = e.value;
              break;
          }          
        } catch (err) {
          console.warn('⚠️ لم يتم العثور على العمود بدقة:', e.fullName);
        }
      }
    },
    getColumnByPath(gridInstance, path) {
      const pathParts = path.match(/columns\[(\d+)\]/g).map(p => parseInt(p.replace(/[^\d]/g, '')));
      let columns = gridInstance.option('columns');
      let column;

      for (let index of pathParts) {
        column = columns[index];
        if (column.columns) {
          columns = column.columns;
        }
      }

      return column;
    },
    async onWarehouseChange(){                      
        await this.Get_Material();
    },
    async onMaterialChanged(e) {
      const prev_item_list = this.DxTag_value_groups;      
      if(localStorage.getItem('array Inventory') != 'null' && localStorage.getItem('array Inventory') != '' && localStorage.getItem('array Inventory') != null){        
        if(prev_item_list.length > e.value.length){
          this.DxTag_value_groups = [...prev_item_list]    
          await this.show_alert('يجب إرسال الطلب أولا قبل إزالة مجموعة ما', "error");
          return
        }          
      }      
      this.DxTag_value_groups = e.value;
      localStorage.setItem('DxTag_value_groups', JSON.stringify(this.DxTag_value_groups));      
      localStorage.setItem('selectedItems2', this.DxTag_value_groups);            
      var x = [];
      if (localStorage.getItem('array Inventory') != 'null' && localStorage.getItem('array Inventory') != null) {
        x = this.Read_Order();        
        //return;
      }
      if(this.DxTag_value_groups =='' || this.DxTag_value_groups == null){        
        this.InventoryMetrial = null;
        return;
      }
      await this.Get_Material()
      this.loading = false;
      for (let i = 0; i < x.length; i++) {
        for (let j = 0; j < this.InventoryMetrial.length; j++) {
          if (this.InventoryMetrial[j].seq == x[i].seq) {
            this.InventoryMetrial[j] = x[i];
            break;
          }
        }
      }
    },    
    calculateCustomValue(e) {
      e.totalValue = this.countItems + 1;
    },
    onRowRemoving(e){
    // ❗ هنا تتدخل قبل تنفيذ الحذف
       /* const confirmDelete = confirm(`هل تريد حذف ${e.data.name1}؟`);
        if (!confirmDelete) {
          e.cancel = true; // ← إلغاء الحذف
        } else {
          // يمكنك تنفيذ منطق إضافي مثل API call أو إشعار
          console.log('سيتم الحذف:', e.data.name1);          */          
          let ListUpdateInventory = localStorage.getItem("array Inventory") == null || localStorage.getItem("array Inventory") == 'null' ? [] : JSON.parse(localStorage.getItem("array Inventory"));
          //this.InventoryMetrial = this.InventoryMetrial.filter(item => item.seq !== e.data.seq);
          
          ListUpdateInventory = ListUpdateInventory.filter(item => item.seq !== e.data.seq);
          if(ListUpdateInventory.length == 0)
            localStorage.setItem("array Inventory", 'null');
          else
            localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory));
          let i = this.InventoryMetrial.indexOf(this.InventoryMetrial.find(item => item.seq === e.data.seq));      
          if(this.InventoryMetrial[i]["expression"] != '' || this.InventoryMetrial[i]["expression2"] !='' || this.InventoryMetrial[i]["expression3"] != ''){
            this.InventoryMetrial[i]["qty_active"] = "";
            this.InventoryMetrial[i]["expression"] = "";
            this.InventoryMetrial[i]["qty_send"] = "";
            this.InventoryMetrial[i]["qty_active2"] = "";
            this.InventoryMetrial[i]["expression2"] = "";
            this.InventoryMetrial[i]["qty_send2"] = "";
            this.InventoryMetrial[i]["qty_active3"] = "";
            this.InventoryMetrial[i]["expression3"] = "";
            this.InventoryMetrial[i]["qty_send3"] = "";             
            this.countItems--;      
            this.InventoryMetrial = [...this.InventoryMetrial];   
            let index = this.InventoryMetrial_CurrentOrder.indexOf(this.InventoryMetrial_CurrentOrder.find(item => item.seq === e.data.seq));  
            this.InventoryMetrial_CurrentOrder.splice(index, 1);
            this.InventoryMetrial_CurrentOrder = [...this.InventoryMetrial_CurrentOrder]        
          }                     
          e.cancel = true;         
       // }
    },    
    onRowPrepared(e) {
      if (e.rowType === "data") {
        
        if(e.data.Inventoried == 'true' || e.data.Inventoried == true){
          e.cellElement.style.cssText = "color: white; background-color: #ff5722";   
          e.cellElement.classList.add('dx-state-readonly');
          e.cellElement.style.pointerEvents = 'none';
          e.cellElement.style.opacity = 0.6;
        }
        else if (e.data.expression != ''|| e.data.expression2 != '' || e.data.expression3 != '') {          
            e.cellElement.style.cssText = "color: white; background-color: green";   
            if(e.column.dataField === 'qty_active2' && (e.data.UFactor2 == 1 || e.data.UFactor2 == 0)){          
              e.cellElement.classList.add('dx-state-readonly');
              e.cellElement.style.pointerEvents = 'none';
              e.cellElement.style.opacity = 0.6;
            }else if(e.column.dataField === 'qty_active3' && (e.data.UFactor3 == 1 || e.data.UFactor3 == 0)){          
              e.cellElement.classList.add('dx-state-readonly');
              e.cellElement.style.pointerEvents = 'none';
              e.cellElement.style.opacity = 0.6;
            }       
          // or
          // e.rowElement.classList.add("my-class");
          // To override alternation color
          // e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
          
        }
        else if(e.column.dataField === 'qty_active2' && (e.data.UFactor2 == 1 || e.data.UFactor2 == 0)){          
          e.cellElement.classList.add('dx-state-readonly');
          e.cellElement.style.pointerEvents = 'none';
          e.cellElement.style.opacity = 0.6;
        }else if(e.column.dataField === 'qty_active3' && (e.data.UFactor3 == 1 || e.data.UFactor3 == 0)){          
          e.cellElement.classList.add('dx-state-readonly');
          e.cellElement.style.pointerEvents = 'none';
          e.cellElement.style.opacity = 0.6;
        }
      }
    },
    onRowPrepared2(e) {
       // if (e.data.qty_send != '0' && e.data.qty_send != '') {
          e.rowElement.style.cssText = "color: white; background-color: red";
          // or
          // e.rowElement.classList.add("my-class");
          // To override alternation color
          // e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
        //}
      
    },
    change_checked_paging(){
        localStorage.setItem("checked_barcode",this.checked_paging);
    },
    change_quantity_barcode(){
        localStorage.setItem("quantity_barcode",this.quantity_barcode);
    },
    handleEnterKey(event) {
      if (event.keyCode === 13) {
        this.add_item();
      }
    },
    applyFilter_num(operation, value) {
      this.selectedOperation = operation;
      this.filterValue_num = value;
    },
    applyFilter_barcode(operation, value) {
      this.selectedOperation = operation;
      this.filterValue_barcode = value;
    },
    applyFilter_name(operation, value) {
      this.selectedOperation = operation;
      this.filterValue_name = value;
    },
    calculateCellValue() {
      return [this.InventoryMetrial.name1, this.InventoryMetrial.num].join(' ');
    },
    async Refresh() {
      this.session = false;
      localStorage.setItem('array Inventory', null);
      this.changevalue(false);
      this.countItems = 0;
    },
    async Save() {


      //localStorage.setItem("array Inventory",JSON.stringify(this.InventoryMetrial));
      for (let i = 0; i < this.InventoryMetrial.length; i++) {
        localStorage.setItem(i + "", this.InventoryMetrial[i])
        /*db.transaction(["employee"], "readwrite")
        .objectStore("employee").add({ 
          id:this.InventoryMetrial[i]["seq"]
        })*/
      }
    },
    Read() {
      this.InventoryMetrial = JSON.parse(localStorage.getItem("array Inventory"));
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: function (options) {
          options.excelCell.font = { name: 'Arial', size: 12 };
          options.excelCell.alignment = { horizontal: 'left' };
        }
      }).then(function () {
        workbook.xlsx.writeBuffer()
          .then(function (buffer) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
          });
      });
    }
    ,
    fortmatResponse(res) {
      return JSON.stringify(res, null, 2);
    },
    async changevalue(e) {
      try{
        if (e == true) {
          //this.session = true;
          //return;  
        }
        this.session = false
        var x = null;
        this.username = localStorage.getItem('username');
        this.loading = true;
        var res = await this.Get_Warehouse();
        if(res == false){
          this.loading = false ;
          return;
        }             
        res = await this.Get_Groups();
        if(res == false){
          this.loading = false ;          
          return;
        }
        this.warehouse_names = [];
        this.items_groups = [];
        this.map = new Map();
        this.map_group = new Map();

        for (let i = 0; i < this.warehouse.length; i++) {
          this.warehouse_names.push(this.warehouse[i].Name);
          this.map.set(this.warehouse[i].Name, this.warehouse[i].Seq);
          this.map_quantity.set(this.warehouse[i].Name, this.warehouse[i].AllowViewQuantity);
          this.map_Inventory.set(this.warehouse[i].Name, this.warehouse[i].AllowInventory);
        }
        for (let i = 0; i < this.DxTag_items_groups.length; i++) {
          this.items_groups.push(this.DxTag_items_groups[i].Name);
          this.map_group.set(this.DxTag_items_groups[i].Name, this.DxTag_items_groups[i].Seq);
        }        
        if (this.warehouse_names.length > 0)
          this.warehouseName = this.warehouse_names[0]
        if (this.items_groups.length > 0)
          this.group = this.items_groups[0]
        if(this.map.get(localStorage.getItem("warehouse_matrial")) != undefined)
          this.warehouseName = localStorage.getItem("warehouse_matrial");
        if(this.map_group.get(localStorage.getItem("group_matrial")) != undefined)
          this.group = localStorage.getItem("group_matrial");
        
        const stored = localStorage.getItem('DxTag_value_groups');
        if (stored) {                  
            this.DxTag_value_groups = JSON.parse(stored);          
        }
        
        /*if(localStorage.getItem("selectedItems2") == '' || localStorage.getItem("selectedItems2") == null)
          {
            this.loading = false;
            return
          }*/
        
        if(this.map.get(localStorage.getItem("warehouse_matrial")) == undefined){
          localStorage.setItem('array Inventory',null)        
        }
        if (localStorage.getItem('array Inventory') != 'null' && localStorage.getItem('array Inventory') != null) {
          x = this.Read_Order();        
          //return;
        }
        res = await this.Get_Material()
        if(res == false){
          this.loading = false ;
          return;
        }
        this.loading = false;
        for (let i = 0; i < x.length; i++) {
          for (let j = 0; j < this.InventoryMetrial.length; j++) {
            if (this.InventoryMetrial[j].seq == x[i].seq) {
              this.InventoryMetrial[j] = x[i];
              break;
            }
          }
        }
      }catch(ex){
        console.log(ex);
        this.loading = false;
      }      
    },
    AddValue(el, dl) {
      try {
        if (el.value.trim() != '') {
          var opSelected = dl.querySelector(`[value="${el.value}"]`);
          var option = document.createElement("option");
          option.value = opSelected.value;
          option.text = opSelected.getAttribute('value');
          return opSelected.getAttribute('label');
        }
        return -1;
      } catch (ex) {
        return -1;
      }
    },
    goBack() {
      this.$router.push({name:"Dashboard"})
    },
    async Log_out() {
      var ip = localStorage.getItem("ip");
      var ip2 = localStorage.getItem("ip2");
      var bcloud = localStorage.getItem("BCloud");
      var str = 'method%3DWEB_Logout%26username%3D' + this.username + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
      var responseData = await this.post_request(str, ip);
      if (responseData.data[0]['State'] == false) {
        this.loading = false;
        await this.show_alert(responseData.data[0]['Response'], "error");
        return;
      }
      await this.show_alert('تم تسجيل الخروج بنجاح', "success");
      localStorage.clear();
      localStorage.setItem("ip", ip);
      localStorage.setItem("BCloud", bcloud);
      localStorage.setItem("ip2", ip2);
      this.$router.push({ name: "login" });
    },
    async post_request(url, ip) {
      try {
        let result = '';
       // const fp1 = await FingerprintJS.load()
       // const result1 = await fp1.get()

        //const visitorId1 = result1.visitorId
        if((localStorage.getItem('username2') == null || localStorage.getItem('username2') == '') && (localStorage.getItem('password2') == null || localStorage.getItem('password2') == '')){        
          return;        
        }        
        if(localStorage.getItem('BCloud') == 'true'){
            url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") ;
            url = {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:url,SESSION:localStorage.getItem("session")};
            ip = localStorage.getItem('ip');
        }else{
          url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") + '%26Ip%3D' +localStorage.getItem("session")   ;
          ip = localStorage.getItem('ip2');
        }
        let response = () => {
          // var str = 'method%3DWEB_GetArtical%26%26username%3D'+localStorage.getItem('username')+'%26%26password%3D'+localStorage.getItem('password')+'%26%26db_guid%3D'+localStorage.getItem('db_guid')+'%26%26android_id%3D'+this.uid;         
          return new Promise(function (resolve) {
            //var str = 'method%3DWEB_Login%26%26username%3D'+this.email+'%26password%3D'+this.password;          
            //axios.post('http://192.168.0.161:9656', 'method%3DESO_GetArticle%26%26salesman%3D1%26longitude%3D43.9852277%26latitude%3D36.2100021%26android_id%3D7c8acc1c8ca5a9ba34112024420610%26search_value%3D%26db_guid%3Dc37595fe-3099-45cf-adb9-f9491f43da1b',
            //axios.post('http://' + ip + ':9657', url,
            //axios.post('http://' + ip , {url},            
            //axios.post( ip , {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:url,SESSION:localStorage.getItem("session")},
            axios.post( ip , url,
            //axios.post('https://' + ip + ':9657', url,
              {
                'Content-type': 'plain/text'
              }).then(response => {
                resolve(response);
                // this.costomers = JSON.stringify(response);
              }).catch(async () => {
                resolve('Error')
              });
          });
        };
        result = await response();
        return result;
      } catch {
        return 'Error';
      }
    },
    async show_alert(text, Icon) {
      await this.$swal.fire({
        //  title: "Are you sure?",
        text: text,
        icon: Icon,
        //iconHtml: "!",
        //showCancelButton: true,
        showConfirmButton: false,
        confirmButtonColor: "#d33",
        //cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        timer: 5000
      });
    },
    async Get_Material() {
      try{
      this.loading = true;
      this.IdWarhouse = this.map.get(this.warehouseName);
      this.warehouse_matrial = this.map.get(this.warehouseName);
      this.groupMat = this.map_group.get(this.group);
      localStorage.setItem('warehouse_matrial',this.warehouseName);
        
      if(this.DxTag_value_groups == ""){
        this.InventoryMetrial = [];
        this.loading = false;        
        return false;
      }
      else{
        this.groupMat = '(' + this.DxTag_value_groups + ')';        
      }      
      if (this.groupMat == undefined) {
        await this.show_alert(' لا يوجد صلاحية جرد لأيّ مادة', "error");
        return false;
      }
      //this.warehouse_matrial = this.AddValue(document.getElementById('AllWarehouses'), document.getElementById('browsers'));

      if (this.warehouse_matrial == undefined) {
        this.InventoryMetrial = [];
        await this.show_alert("لا يوجد صلاحية جرد لأيّ مستودع", "error");
        return false;
      }
      else {
        var str = 'method%3DWEB_GetVersion%26username%3D' + this.username + '%26password%3D' + this.password + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
        let responseData = await this.post_request(str, localStorage.getItem("ip"));
        if (responseData == 'Error') {
          this.loading = false;
          await this.show_alert('فشل في الاتصال بالمخدم', "error");
          return false;
        }
        if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
          if (this.groupMat == undefined)
            this.groupMat = '(' + 0 +')';
          str = 'method%3DWEB_GetArtical%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26Group_Mat%3D' + this.groupMat + '%26%26android_id%3D' + this.uid + '%26Warehouse%3D' + this.warehouse_matrial;
          responseData = await this.post_request(str, localStorage.getItem("ip"))
          if (responseData == 'Error') {
            this.loading = false;
            await this.show_alert('فشل في الاتصال بالمخدم', "error");
            return false;
          }
          this.InventoryMetrial = responseData.data[0]['dataTable']
        } else {
          //localStorage.clear();
          await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
          this.loading = false;
          return false;
          //this.$router.push({ name: 'login' })
        }
      }
      this.loading = false;
      return true;
      }catch(ex){
        this.loading = false;
        console.log(ex);
        return false;
      }      
    },
    async Get_Orders() {
      this.loading = true;
      if (this.type == 'Orders') {
        try {
          let responseData;
          var str = 'method%3DWEB_GetVersion%26username%3D' + this.username + '%26password%3D' + this.password + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
          responseData = await this.post_request(str, localStorage.getItem("ip"));
          if (responseData == 'Error') {
            this.loading = false;
            await this.show_alert('فشل في الاتصال بالمخدم', "error");
            return;
          }

          if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
            str = 'method%3DWEB_GetInvoices%26%26username%3D' + localStorage.getItem('username') + '%26%26FromDate%3D' + this.FromDate + '%26%26ToDate%3D' + this.ToDate + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
            responseData = await this.post_request(str, localStorage.getItem("ip"));
            if (responseData == 'Error') {
              this.loading = false;
              await this.show_alert('فشل في الاتصال بالمخدم', "error");
              return;
            }
            //this.InventoryMetrial = responseData.data[0]['dataTable']
            this.orders = responseData.data[0]['dataTable']

          } else {
            //localStorage.clear();
            await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
            this.loading = false;
            this.$router.push({ name: 'login' })
          }
        } catch {
          this.loading = false
          await this.show_alert('فشل الاتصال في المخدم', "error");
        }
      }
      this.loading = false;
    },
    async Get_Groups() {
      try{
        var str = 'method%3DWEB_GetGroups%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
        var responseData = await this.post_request(str, localStorage.getItem("ip"));
        this.DxTag_items_groups = responseData.data[0]['dataTable']
              
        if(this.DxTag_items_groups.length == 0){
          this.DxTag_value_groups ='';
          this.groupMat = '';
          this.selectedItems2 = '';
          localStorage.setItem('selectedItems2','');
          localStorage.setItem('selectedTags','');       
          return false   
        }
        return true;
      }catch(ex){
        console.log(ex);
        return false;
      }      
    },
    async Get_Warehouse() {
      try{        
        var str = 'method%3DWEB_GetVersion%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
        let responseData = await this.post_request(str, localStorage.getItem("ip"));
        if (responseData == 'Error') {          
          await this.show_alert('فشل في الاتصال بالمخدم', "error");
          this.loading = false;
          return false;
        }
        if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
          str = 'method%3DWEB_GetWarehouse%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
          responseData = await this.post_request(str, localStorage.getItem("ip"));
          if (responseData == 'Error') {            
            await this.show_alert('فشل في الاتصال بالمخدم', "error");
            this.loading = false;
            return false;
          }
          //this.InventoryMetrial = responseData.data[0]['dataTable']
          this.warehouse = responseData.data[0]['dataTable']    
          return true;      
        } else {          
          //localStorage.clear();          
          await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
          this.loading = false;
          return false;
          //this.$router.push({ name: 'login' })
        }
      }catch(ex){
        console.error(ex)
        this.loading = false;
        return false;
      }      
    },
    async Update_Inventory(type) {
      try{
        this.loading = true;
        let ListUpdateInventory1 = [];
        let ListUpdateInventory2 = [];
        let ListUpdateInventory3 = [];
        let ListUpdateInventory_save = [];
        let quantity = 0, quantity2 = 0, quantity3 = 0; // unit2 = 1, unit3 = 2,
        let point = 0, point2 = 0, point3 = 0; 
        for (let i = 0; i < this.InventoryMetrial.length; i++) {    
          quantity = 1;
          point = parseInt(this.InventoryMetrial[i]['Point']);
          quantity2 = parseFloat(this.InventoryMetrial[i]['UFactor2']);
          point2 = parseInt(this.InventoryMetrial[i]['Point2']);
          quantity3 = parseFloat(this.InventoryMetrial[i]['UFactor3']);
          point3 = parseInt(this.InventoryMetrial[i]['Point3']);
          if (this.InventoryMetrial[i]['Defunit'] == '1') {
            quantity = parseFloat(this.InventoryMetrial[i]['UFactor2']);
            point = parseInt(this.InventoryMetrial[i]['Point2']);
            quantity2 = 1;
            point2 = parseInt(this.InventoryMetrial[i]['Point']);
            quantity3 = parseFloat(this.InventoryMetrial[i]['UFactor3']);
            point3 = parseInt(this.InventoryMetrial[i]['Point3']);
          } else if (this.InventoryMetrial[i]['Defunit'] == '2') {
            quantity = parseFloat(this.InventoryMetrial[i]['UFactor3']);
            point = parseInt(this.InventoryMetrial[i]['Point3']);
            quantity2 = 1;
            point2 = parseInt(this.InventoryMetrial[i]['Point']);
            quantity3 = parseFloat(this.InventoryMetrial[i]['UFactor2']);
            point3 = parseInt(this.InventoryMetrial[i]['Point2']);
          }
          //console.log("this.InventoryMetrial[i]['qty_send'] : " + this.InventoryMetrial[i]['qty_send'] != '' + "   this.InventoryMetrial[i]['qty_send2'] : "  + this.InventoryMetrial[i]['qty_send2'] != '' + "this.InventoryMetrial[i]['qty_send3'] : " + this.InventoryMetrial[i]['qty_send3'] )
          if (this.InventoryMetrial[i]['qty_send'] != '' || this.InventoryMetrial[i]['qty_send2'] != '' || this.InventoryMetrial[i]['qty_send3'] != '') {
            ListUpdateInventory_save.push(this.InventoryMetrial[i]);
            var qty = 0;
            if (this.InventoryMetrial[i]['qty_send'] != '') {
              if (type == true)
                qty = (parseFloat(qty) + quantity * (parseFloat(this.InventoryMetrial[i]['qty_send']) - parseFloat(this.InventoryMetrial[i]['qty']))).toFixed(point);
              else {
                qty = (parseFloat(qty) + quantity * (parseFloat(this.InventoryMetrial[i]['qty_send']))).toFixed(point);
              }
            }
            if (this.InventoryMetrial[i]['qty_send2'] != '') {
              qty = (parseFloat(qty) + quantity2 * parseFloat(this.InventoryMetrial[i]['qty_send2'])).toFixed(point2);
            }
            if (this.InventoryMetrial[i]['qty_send3'] != '') {
              qty = (parseFloat(qty) + quantity3 * parseFloat(this.InventoryMetrial[i]['qty_send3'])).toFixed(point3);
            }
            if (type == true)
              ListUpdateInventory1.push({ 'Seq': this.InventoryMetrial[i]['seq'], 'Price': 0, 'Unit': this.InventoryMetrial[i]['Defunit'], 'Warehouse': this.warehouse_matrial, 'Quantity': qty, 'Subtotal': 0, Remarks: this.InventoryMetrial[i]['Remarks'] });
            else {
              ListUpdateInventory1.push({ 'Seq': this.InventoryMetrial[i]['seq'], 'Price': 0, 'Unit': this.InventoryMetrial[i]['Defunit'], 'Warehouse': this.warehouse_matrial, 'Quantity': qty, 'Subtotal': 0, Remarks: this.InventoryMetrial[i]['Remarks'] });
            }
          }
        }
        if (this.warehouse_matrial == '-1' || (ListUpdateInventory1.length == 0 && ListUpdateInventory2.length == 0 && ListUpdateInventory3.length == 0)) {
          await this.show_alert('لم يتم التعديل على جرد المواد', "error");
          this.loading = false;
          return;
        }
        let responseData;
        for (let i = 0; i < 3; i++) {
          let ListUpdateInventory = [];
          if (i == 0) {
            if (ListUpdateInventory1.length == 0)
              continue;
            ListUpdateInventory = ListUpdateInventory1;
          }
          else if (i == 1) {
            if (ListUpdateInventory2.length == 0)
              continue;
            ListUpdateInventory = ListUpdateInventory2;
          } else {
            if (ListUpdateInventory3.length == 0)
              continue;
            ListUpdateInventory = ListUpdateInventory3;
          }
          const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
          let token = ''
          for (let i = 0; i < 4; i++) {
            token += str[parseInt(Math.random() * str.length)];
          }
          var type_order = "";
          if (type == true)
            type_order = "Inventory";
          else
            type_order = "Entry";
          const date = new Date();
          const milliseconds = date.getMilliseconds();
          const houer = date.getHours();
          const minutes = date.getMinutes();
          const second = date.getSeconds();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          token += '-' + year + month + day + '+' + houer + minutes + second + '+' + milliseconds
          token = localStorage.getItem('token') ;
          const date_add = year + '-' + month + '-' + day + '+' + houer + ':' + minutes + ':' + second;
          //console.log("******************"+this.$route.name);
          const method = 'WEB_InsertInvoice', account = 11, customer_name = '', remarks = '', total = 0, currency = 0,
            items_count = ListUpdateInventory.length, tag_printer = '', flag = true, localseq = 0, total_discount = 0, to_warehouse = this.map.get(this.warehouseName), is_order = true,
            IsInventory = true, kind = 3,
            longitude = 0, latitude = 0;
          
          let urlPost = 'method=' + method + '&&account=' + account + '&customer_name=' + customer_name + '&username=' + localStorage.getItem("username") + '&password=' + localStorage.getItem("password");
          urlPost += '&remarks=' + remarks + '&total=' + total + '&currency=' + currency + '&items_count=' + items_count + '&items_json=' + JSON.stringify(ListUpdateInventory);
          urlPost += '&tag_printer=' + tag_printer + '&token=' + token + '&date_add=' + date_add + '&flag=' + flag;
          urlPost += '&localseq=' + localseq + '&total_discount=' + total_discount + '&to_warehouse=' + to_warehouse + '&is_order=' + is_order + '&IsInventory=' + IsInventory + '&kind=' + kind;
          urlPost += '&longitude=' + longitude + '&latitude=' + latitude + '&db_guid=' + localStorage.getItem('db_guid') + '&android_id=' + this.uid;
          urlPost += '&typeOrder=' + type_order;
          const encoded = encodeURIComponent(urlPost);

          responseData = await this.post_request(encoded, localStorage.getItem("ip"));
          if (responseData == 'Error') {
            localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory_save))
            this.loading = false;
            await this.show_alert('فشل في الاتصال بالمخدم', "error");
            this.loading = false;
            return;
          }
          if (responseData.data[0]['State'] == false) {
            await this.show_alert(responseData.data[0]['Response'], "error");
            //this.$router.push({ name: "login" });
            this.loading = false;
            return;
          } else {
            await this.show_alert(responseData.data[0]['Response'], "success");
            for(let i=0;i<this.InventoryMetrial.length;i++){
              if (this.InventoryMetrial[i]['qty_send'] != '' || this.InventoryMetrial[i]['qty_send2'] != '' || this.InventoryMetrial[i]['qty_send3'] != '') {
                this.InventoryMetrial_PrevuiosOrder.push(this.InventoryMetrial[i]);
              }
            }
          }
        }
        this.loading = false;
        this.Refresh();
      }catch(ex){
        console.log(ex)
        this.loading = false;
      }      
    },
    onRowUpdated(e){   
      try{
          let i = this.InventoryMetrial.indexOf(this.InventoryMetrial.find(item => item.seq === e.key));                      
          if (this.InventoryMetrial[i]["qty_active"] != '' && this.InventoryMetrial[i]["qty_active"] != null) {
            if (this.InventoryMetrial[i]["expression"] == '') {
              this.InventoryMetrial[i]["expression"] += this.InventoryMetrial[i]["qty_active"];
              this.InventoryMetrial[i]['qty_send'] = this.InventoryMetrial[i]["qty_active"];              
            }
            else {
              if (parseFloat(this.InventoryMetrial[i]["qty_active"]) > 0)
                this.InventoryMetrial[i]["expression"] += '+' + this.InventoryMetrial[i]["qty_active"];
              else if (parseFloat(this.InventoryMetrial[i]["qty_active"]) < 0)
                this.InventoryMetrial[i]["expression"] += this.InventoryMetrial[i]["qty_active"];
              this.InventoryMetrial[i]['qty_send'] = parseFloat(this.InventoryMetrial[i]['qty_send']) + parseFloat(this.InventoryMetrial[i]["qty_active"]);
            }          
            this.InventoryMetrial[i]["qty_active"] = '';
          }
          if (this.InventoryMetrial[i]["qty_active2"] != '' && this.InventoryMetrial[i]["qty_active2"] != null) {
            if (this.InventoryMetrial[i]["expression2"] == '') {
              this.InventoryMetrial[i]["expression2"] += this.InventoryMetrial[i]["qty_active2"];
              this.InventoryMetrial[i]['qty_send2'] = this.InventoryMetrial[i]["qty_active2"];
            }
            else {
              if (parseFloat(this.InventoryMetrial[i]["qty_active2"]) > 0)
                this.InventoryMetrial[i]["expression2"] += '+' + this.InventoryMetrial[i]["qty_active2"];
              else if (parseFloat(this.InventoryMetrial[i]["qty_active2"]) < 0)
                this.InventoryMetrial[i]["expression2"] += this.InventoryMetrial[i]["qty_active2"];
              this.InventoryMetrial[i]['qty_send2'] = parseFloat(this.InventoryMetrial[i]['qty_send2']) + parseFloat(this.InventoryMetrial[i]["qty_active2"]);
            }
            this.InventoryMetrial[i]["qty_active2"] = '';
          }
          if (this.InventoryMetrial[i]["qty_active3"] != '' && this.InventoryMetrial[i]["qty_active3"] != null) {
            if (this.InventoryMetrial[i]["expression3"] == '') {
              this.InventoryMetrial[i]["expression3"] += this.InventoryMetrial[i]["qty_active3"];
              this.InventoryMetrial[i]['qty_send3'] = this.InventoryMetrial[i]["qty_active3"];
            }
            else {
              if (parseFloat(this.InventoryMetrial[i]["qty_active3"]) > 0)
                this.InventoryMetrial[i]["expression3"] += '+' + this.InventoryMetrial[i]["qty_active3"];
              else if (parseFloat(this.InventoryMetrial[i]["qty_active3"]) < 0)
                this.InventoryMetrial[i]["expression3"] += this.InventoryMetrial[i]["qty_active"];
              this.InventoryMetrial[i]['qty_send3'] = parseFloat(this.InventoryMetrial[i]['qty_send3']) + parseFloat(this.InventoryMetrial[i]["qty_active3"]);
            }
            this.InventoryMetrial[i]["qty_active3"] = '';
          }
          
          let ListUpdateInventory = [];
          ListUpdateInventory = localStorage.getItem("array Inventory") == null || localStorage.getItem("array Inventory") =='null'? [] : JSON.parse(localStorage.getItem("array Inventory"));
          if(this.InventoryMetrial == null || this.InventoryMetrial.length == 0)
            return;
          
          if (toString(this.InventoryMetrial[i]['qty_send']) != '' || toString(this.InventoryMetrial[i]['qty_send2']) != '' || toString(this.InventoryMetrial[i]['qty_send3']) != '') {
            for(var j = 0 ; j <ListUpdateInventory.length ; j++){            
              if(ListUpdateInventory[j]["seq"] == this.InventoryMetrial[i]["seq"]){
                ListUpdateInventory[j] = this.InventoryMetrial[i];              
                localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory))                     
                return;
              }
            }
            
            this.countItems++;          
            ListUpdateInventory.push(this.InventoryMetrial[i]);          
          }
        // localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory))
          if (this.warehouse_matrial == '-1' || ListUpdateInventory.length == 0) {

          //await this.show_alert("لم يتم التعديل على جرد المواد", "error");
        } else {
          localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory))
          localStorage.setItem("warehouse_matrial", this.warehouseName)        
          localStorage.setItem("Items", this.countItems)
          localStorage.setItem("group_matrial", this.group)    
        }
          //this.Save_Order();
      } catch(ex){
        console.log(ex)
      }        
    },
    saving(){
      //console.log(e.changes[0].key);
    },
    saved_value() {
     /*for (let i = 0; i < this.InventoryMetrial.length; i++) {
        if (this.InventoryMetrial[i]["qty_active"] != '' && this.InventoryMetrial[i]["qty_active"] != null) {
          if (this.InventoryMetrial[i]["expression"] == '') {
            this.InventoryMetrial[i]["expression"] += this.InventoryMetrial[i]["qty_active"];
            this.InventoryMetrial[i]['qty_send'] = this.InventoryMetrial[i]["qty_active"];
          }
          else {
            if (parseFloat(this.InventoryMetrial[i]["qty_active"]) > 0)
              this.InventoryMetrial[i]["expression"] += '+' + this.InventoryMetrial[i]["qty_active"];
            else if (parseFloat(this.InventoryMetrial[i]["qty_active"]) < 0)
              this.InventoryMetrial[i]["expression"] += this.InventoryMetrial[i]["qty_active"];
            this.InventoryMetrial[i]['qty_send'] = parseFloat(this.InventoryMetrial[i]['qty_send']) + parseFloat(this.InventoryMetrial[i]["qty_active"]);
          }
          this.InventoryMetrial[i]["qty_active"] = '';
        }
        if (this.InventoryMetrial[i]["qty_active2"] != '' && this.InventoryMetrial[i]["qty_active2"] != null) {
          if (this.InventoryMetrial[i]["expression2"] == '') {
            this.InventoryMetrial[i]["expression2"] += this.InventoryMetrial[i]["qty_active2"];
            this.InventoryMetrial[i]['qty_send2'] = this.InventoryMetrial[i]["qty_active2"];
          }
          else {
            if (parseFloat(this.InventoryMetrial[i]["qty_active2"]) > 0)
              this.InventoryMetrial[i]["expression2"] += '+' + this.InventoryMetrial[i]["qty_active2"];
            else if (parseFloat(this.InventoryMetrial[i]["qty_active2"]) < 0)
              this.InventoryMetrial[i]["expression2"] += this.InventoryMetrial[i]["qty_active2"];
            this.InventoryMetrial[i]['qty_send2'] = parseFloat(this.InventoryMetrial[i]['qty_send2']) + parseFloat(this.InventoryMetrial[i]["qty_active2"]);
          }
          this.InventoryMetrial[i]["qty_active2"] = '';
        }
        if (this.InventoryMetrial[i]["qty_active3"] != '' && this.InventoryMetrial[i]["qty_active3"] != null) {
          if (this.InventoryMetrial[i]["expression3"] == '') {
            this.InventoryMetrial[i]["expression3"] += this.InventoryMetrial[i]["qty_active3"];
            this.InventoryMetrial[i]['qty_send3'] = this.InventoryMetrial[i]["qty_active3"];
          }
          else {
            if (parseFloat(this.InventoryMetrial[i]["qty_active3"]) > 0)
              this.InventoryMetrial[i]["expression3"] += '+' + this.InventoryMetrial[i]["qty_active3"];
            else if (parseFloat(this.InventoryMetrial[i]["qty_active3"]) < 0)
              this.InventoryMetrial[i]["expression3"] += this.InventoryMetrial[i]["qty_active"];
            this.InventoryMetrial[i]['qty_send3'] = parseFloat(this.InventoryMetrial[i]['qty_send3']) + parseFloat(this.InventoryMetrial[i]["qty_active3"]);
          }
          this.InventoryMetrial[i]["qty_active3"] = '';
        }
      }
      this.Save_Order();*/

    },
    async Send_Quantity() {
      let ListUpdateInventory = [];
      for (let i = 0; i < this.InventoryMetrial.length; i++) {
        if (this.InventoryMetrial[i]['qty'] != this.InventoryMetrial[i]['qty_active'] || (this.InventoryMetrial[i]['qty_add'] != 0 && this.InventoryMetrial[i]['qty_add'] != null)) {
          if (this.InventoryMetrial[i]['qty_add'] == null)
            this.InventoryMetrial[i]['qty_add'] = 0;
          this.InventoryMetrial[i]['qty_send'] = (parseFloat(this.InventoryMetrial[i]['qty_active']) + parseFloat(this.InventoryMetrial[i]['qty_add']));
          ListUpdateInventory.push({ 'Seq': this.InventoryMetrial[i]['seq'], 'Price': 0, 'Unit': 0, 'Warehouse': this.warehouse_matrial, 'Quantity': this.InventoryMetrial[i]['qty_send'], 'Subtotal': 0, Remarks: this.InventoryMetrial[i]['Remarks'] });
        }
        if (this.InventoryMetrial[i]['qty2'] != this.InventoryMetrial[i]['qty_active2'] || (this.InventoryMetrial[i]['qty_add2'] != 0 && this.InventoryMetrial[i]['qty_add2'] != null)) {
          if (this.InventoryMetrial[i]['qty_add2'] == null)
            this.InventoryMetrial[i]['qty_add2'] = 0;
          this.InventoryMetrial[i]['qty_send2'] = (parseFloat(this.InventoryMetrial[i]['qty_active2']) + parseFloat(this.InventoryMetrial[i]['qty_add2'])) * parseFloat(this.InventoryMetrial[i]['UFactor2']);
          ListUpdateInventory.push({ 'Seq': this.InventoryMetrial[i]['seq'], 'Price': 0, 'Unit': 1, 'Warehouse': this.warehouse_matrial, 'Quantity': this.InventoryMetrial[i]['qty_send2'], 'Subtotal': 0, Remarks: this.InventoryMetrial[i]['Remarks'] });
        }
        if (this.InventoryMetrial[i]['qty3'] != this.InventoryMetrial[i]['qty_active3'] || (this.InventoryMetrial[i]['qty_add3'] != 0 && this.InventoryMetrial[i]['qty_add3'] != null)) {
          if (this.InventoryMetrial[i]['qty_add3'] == null)
            this.InventoryMetrial[i]['qty_add3'] = 0;
          this.InventoryMetrial[i]['qty_send3'] = (parseFloat(this.InventoryMetrial[i]['qty_active3']) + parseFloat(this.InventoryMetrial[i]['qty_add3'])) * parseFloat(this.InventoryMetrial[i]['UFactor3']);
          ListUpdateInventory.push({ 'Seq': this.InventoryMetrial[i]['seq'], 'Price': 0, 'Unit': 2, 'Warehouse': this.warehouse_matrial, 'Quantity': this.InventoryMetrial[i]['qty_send3'], 'Subtotal': 0, Remarks: this.InventoryMetrial[i]['Remarks'] });
        }
      }
      if (this.warehouse_matrial == '-1' || ListUpdateInventory.length == 0) {
        await this.show_alert('لم يتم التعديل على جرد المواد', "error");
        return;
      }
      const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
      let token = ''
      for (let i = 0; i < 4; i++) {
        token += str[parseInt(Math.random() * str.length)];
      }
      const date = new Date();
      const milliseconds = date.getMilliseconds();
      const houer = date.getHours();
      const minutes = date.getMinutes();
      const second = date.getSeconds();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      token += '-' + year + month + day + '+' + houer + minutes + second + '+' + milliseconds
      const date_add = year + '-' + month + '-' + day + '+' + houer + ':' + minutes + ':' + second;      
      const method = 'WEB_InsertInvoice', account = 11, customer_name = '', remarks = '', total = 0, currency = 0,
        items_count = ListUpdateInventory.length, tag_printer = '', flag = true, localseq = 0, total_discount = 0, to_warehouse = this.warehouseName, is_order = true,
        IsInventory = true, kind = 3,longitude = 0, latitude = 0;      
      let urlPost = 'method=' + method + '&&account=' + account + '&customer_name=' + customer_name + '&username=' + localStorage.getItem("username") + '&password=' + localStorage.getItem("password");
      urlPost += '&remarks=' + remarks + '&total=' + total + '&currency=' + currency + '&items_count=' + items_count + '&items_json=' + JSON.stringify(ListUpdateInventory);
      urlPost += '&tag_printer=' + tag_printer + '&token=' + token + '&date_add=' + date_add + '&flag=' + flag;
      urlPost += '&localseq=' + localseq + '&total_discount=' + total_discount + '&to_warehouse=' + to_warehouse + '&is_order=' + is_order + '&IsInventory=' + IsInventory + '&kind=' + kind;
      urlPost += '&longitude=' + longitude + '&latitude=' + latitude + '&db_guid=' + localStorage.getItem('db_guid') + '&android_id=' + this.uid;
      const encoded = encodeURIComponent(urlPost);
      let responseData = await this.post_request(encoded, localStorage.getItem("ip"));
      if (responseData == 'Error') {
        this.loading = false;
        await this.show_alert('فشل في الاتصال بالمخدم', "error");
        return;
      }
      if (responseData.data[0]['State'] == false) {
        await this.show_alert(responseData.data[0]['Response'], "error");
        this.$router.push({ name: "login" });
      } else {
        this.Get_Material()
        await this.show_alert(responseData.data[0]['Response'], "success");
      }
    },
    Read_Order() {
      this.InventoryMetrial = JSON.parse(localStorage.getItem("array Inventory"));
      this.warehouse_matrial = localStorage.getItem("warehouse_matrial");
      return this.InventoryMetrial;
    },
    add_item() {
      document.getElementById("input").focus(); 
      var sub_barcode  = document.getElementById("input").value; 
      sub_barcode = sub_barcode.replace(/[٠-٩]/g, d => englishDigits[arabicDigits.indexOf(d)])   ;
      const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
      const englishDigits = '0123456789';           
      if (this.filterValue_barcode != '' || sub_barcode != '') {                     
        for (let i = 0; i < this.InventoryMetrial.length; i++) {   

          var sub_bar = false;
          for (let j = 0; j < this.InventoryMetrial[i].other_barcode.length; j++) {   
            if(this.InventoryMetrial[i].other_barcode[j]["barcode"] == sub_barcode){
              sub_bar = true;
              break;
            }
          }
          if ((sub_bar == true || this.InventoryMetrial[i]['barcode'] == sub_barcode) && this.InventoryMetrial[i]['Inventoried'] == false) {    
            this.focusedRowKey = this.InventoryMetrial[i]['seq'];                    
            if (this.InventoryMetrial[i]['expression'] == ''){
              this.InventoryMetrial[i]['expression'] += this.quantity_barcode ;           
            }              
            else{
              if(this.quantity_barcode>=0)
                this.InventoryMetrial[i]['expression'] += '+' + this.quantity_barcode;
              else
                this.InventoryMetrial[i]['expression'] +=''+ this.quantity_barcode;
            }
            if (this.InventoryMetrial[i]['qty_send'] == '' || this.InventoryMetrial[i]['qty_send'] == null)
              this.InventoryMetrial[i]['qty_send'] = 0;
            this.InventoryMetrial[i]['qty_send'] = parseInt(this.InventoryMetrial[i]['qty_send']) + this.quantity_barcode
            this.filterValue_barcode = '';
            document.getElementById("input").value = '';            
            this.playNote(1);
            let ListUpdateInventory = [];
            let isMatEdit = false;
            ListUpdateInventory = localStorage.getItem("array Inventory") == null || localStorage.getItem("array Inventory") =='null'? [] : JSON.parse(localStorage.getItem("array Inventory"));
            if(this.InventoryMetrial == null || this.InventoryMetrial.length == 0)
              return;              
            if (toString(this.InventoryMetrial[i]['qty_send']) != '' || toString(this.InventoryMetrial[i]['qty_send2']) != '' || toString(this.InventoryMetrial[i]['qty_send3']) != '') {               
              for(var j = 0 ; j <ListUpdateInventory.length ; j++){            
                if(ListUpdateInventory[j]["seq"] == this.InventoryMetrial[i]["seq"]){
                  ListUpdateInventory[j] = this.InventoryMetrial[i];    
                  isMatEdit = true;            
                  break;
                }
              }
              if(isMatEdit == false){
                this.countItems++;          
                ListUpdateInventory.push(this.InventoryMetrial[i]);   
                this.InventoryMetrial_CurrentOrder.push(this.InventoryMetrial[i]);                                                          
              }                 
            }
            localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory))
            localStorage.setItem("warehouse_matrial", this.warehouseName)        
            localStorage.setItem("Items", this.countItems)
            localStorage.setItem("group_matrial", this.group)                
            return;                     
          }
          else if((sub_bar == true || this.InventoryMetrial[i]['barcode'] == sub_barcode) && this.InventoryMetrial[i]['Inventoried'] == true){
            this.show_alert(' المادة ' + this.InventoryMetrial[i]['name1'] + ' تم مزامنة جردها ', "error");
            document.getElementById("input").value = '';
            this.filterValue_barcode = '';
            this.playNote(0);
            return;
          }
        }
      }
      this.show_alert(' المادة ' + this.filterValue_barcode + ' غير موجودة ', "error");
      document.getElementById("input").value = '';
      this.filterValue_barcode = '';
      this.playNote(0);
    },
    playNote(type) {
      let audio;
      if (type == 1) {
        audio = new Audio('barcode.mp3');
      } else {
        audio = new Audio('barcode2.mp3');
      }
      audio.addEventListener("canplaythrough", () => {
        var resp = audio.play();
        if (resp !== undefined) {
          resp
            .then((_) => {
              console.log(_);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    async Save_Order() {      
      let ListUpdateInventory = [];
      this.countItems = 0;
      for (let i = 0; i < this.InventoryMetrial.length; i++) {        
        if (toString(this.InventoryMetrial[i]['qty_send']) != '' || toString(this.InventoryMetrial[i]['qty_send2']) != '' || toString(this.InventoryMetrial[i]['qty_send3'] != '')) {
          ListUpdateInventory.push(this.InventoryMetrial[i]);
          this.countItems++;
        }
      }
      if (this.warehouse_matrial != '-1' && ListUpdateInventory.length != 0) {      
        localStorage.setItem("array Inventory", JSON.stringify(ListUpdateInventory))
        localStorage.setItem("warehouse_matrial", this.warehouseName)        
        localStorage.setItem("Items", this.countItems)
        localStorage.setItem("group_matrial", this.group)    
      }
    },
  },
  async beforeCreate() {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    this.visitorId = result.visitorId
  },
 async created() {    
    try{
      this.loading = true;
      let response = () => {
        if (localStorage.getItem('password') == null)
          this.password = '';
        else
          this.password = localStorage.getItem('password');
        if (localStorage.getItem('username') == null)
          this.email = '';
        else
          this.email = localStorage.getItem('username');
        if (this.email == '' && this.password == '' )
          return;
        if(this.db_guid == ''){
          this.$router.push({name:'login'})
          return;
        }
        var str = 'method%3DWEB_Login_Check%26username%3D' + this.email + '%26password%3D' + this.password + '%26android_id%3D' + this.uid + '%26db_guid%3D' + this.db_guid+'%26SESSION%3D%26token%3D' + localStorage.getItem('token') ;
        var ip ='';
        if(localStorage.getItem('BCloud')=='true'){
          str +="%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") ;
          str = {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:str,SESSION:localStorage.getItem('session')};            
          ip = localStorage.getItem("ip");
        }else{
          str +="%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26Ip%3D';              
          ip = localStorage.getItem("ip2");
        }
        return new Promise(function (resolve) {
          axios.post(ip, str,
            {
              'Content-type': 'plain/text'
            }).then(response => {
              resolve(response);
            });
        });
      };
      let responseData = await response();
        if (responseData.data[0]['State'] == true) {
            localStorage.setItem("X", responseData.data[0]['db_guid']);
            
        } else {
            var t = localStorage.getItem('token');
            //localStorage.clear();
            localStorage.setItem('token',t);
            await this.$swal.fire({
                  //  title: "Are you sure?",
                  text: responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'],
                  icon: "error",
                  //iconHtml: "!",
                  //showCancelButton: true,
                  showConfirmButton: false,
                  confirmButtonColor: "#d33",
                  confirmButtonText: "OK",
                  timer: 5000
                });
            this.loading = false;
            return;
            //this.$router.push({name:'login'})
          }
    }catch(ex){
      console.error(ex)
      this.loading = false;
      return;
    }
    

    localStorage.setItem("CurrentPage","Inventory");
    if (localStorage.getItem('array Inventory') == 'null' || localStorage.getItem('array Inventory') == null) {
      this.session = false;
      this.changevalue(false);
      this.countItems = 0;
      return;
    } else{
      this.session = true;    
      this.countItems = localStorage.getItem('Items')      
    }      
  }
};

</script>
<style lang="scss" scoped>
@import "@/scss/components/inputs/_animatedInput.scss";
@import "@/scss/components/inputs/checkbox.scss";
</style>
<style scoped>

.custom-tagbox {
  max-width: 50vw;
}

#gridContainer {
  height: 440px;
}

.colorOrange {
  /*background-color: #FF5722;*/
  background-color: #1278C0;
}

.padding {
  margin: 10px;
}

.textRTL {
  text-align: right;
  margin: 10px;
}



@keyframes l2 {
  100% {
    background-size: 110%
  }
}
.t {
  width: 100%;
  height: 100vh;
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

body {
 /* font-family: Arial, Helvetica, sans-serif;*/
}

* {
  box-sizing: border-box;
}

button {
  background-color: #04AA6D;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
  opacity: 0.9;
}

button:hover {
  opacity: 1;
}

.cancelbtn,
.deletebtn {
  float: left;
  width: 50%;
}

.cancelbtn {
  background-color: #ccc;
  color: black;
}

.deletebtn {
  background-color: #f44336;
}

.container1 {
  padding: 16px;
  text-align: center;
}

/* The Modal (background) */
.modal1 {
  display: block;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: #474e5d;
  padding-top: 50px;
}

/* Modal Content/Box */
.modal-content1 {
  background-color: #fefefe;
  margin: 5% auto 15% auto;
  /* 5% from the top, 15% from the bottom and centered */
  border: 1px solid #888;
  width: 80%;
  /* Could be more or less, depending on screen size */
}

/* Style the horizontal ruler */
hr {
  border: 1px solid #f1f1f1;
  margin-bottom: 25px;
}

/* The Modal Close Button (x) */
.close1 {
  position: absolute;
  right: 35px;
  top: 15px;
  font-size: 40px;
  font-weight: bold;
  color: #f1f1f1;
}

.close1:hover,
.close1:focus {
  color: #f44336;
  cursor: pointer;
}

/* Clear floats */
.clearfix1::after {
  content: "";
  clear: both;
  display: table;
}
.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around ;/*space-between; /* أو space-around أو center حسب الحاجة */
  align-items: center; /* لمحاذاة عمودية */
  width: 100%;
}

.box {
  flex: 1; /* يقسم العرض بالتساوي */
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 3px;
  color: white;
  text-align: center;
}

.left {
  /*background-color: #43539e;*/
}

.right {
  /*background-color: #43539e;*/
}

 body,html {
        height: 100%;
        width:100%;
        text-align: center;
        background:#dcdcdc;
        margin:0;
        padding:0;
        position:relative;
    }
    /*.dx-popup-content{*/
        /*padding: 0px !important;*/
        /*padding-top: 5px !important;*/
    /*}*/
    /*PRELOADING------------ */
    #overlayer {
        width:100%;
        height:100%;
        position:absolute;
        z-index:1;
        background:#4a4a4a;
    }
    .loader {
        display: inline-block;
        width: 30px;
        height: 30px;
        position: absolute;
        z-index:3;
        border: 4px solid #Fff;
        top: 50%;
        animation: loader 2s infinite ease;
    }

    .loader-inner {
        vertical-align: top;
        display: inline-block;
        width: 100%;
        background-color: #fff;
        animation: loader-inner 2s infinite ease-in;
    }

    @keyframes loader {
        0% {
            transform: rotate(0deg);
        }

        25% {
            transform: rotate(180deg);
        }

        50% {
            transform: rotate(180deg);
        }

        75% {
            transform: rotate(360deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes loader-inner {
        0% {
            height: 0%;
        }

        25% {
            height: 0%;
        }

        50% {
            height: 100%;
        }

        75% {
            height: 100%;
        }

        100% {
            height: 0%;
        }
    }

/* Change styles for cancel button and delete button on extra small screens */
@media screen and (max-width: 300px) {

  .cancelbtn,
  .deletebtn {
    width: 100%;
  }
}
</style>